export default ({ request }) => ({
  personalTskInfoCenterListApi(data = {}) {
    return request({
      url: '/digitalCenter/tsk/info/center/list',
      method: 'post',
      data,
    })
  },
  personalTskInfoChildListApi(data = {}) {
    return request({
      url: '/digitalCenter/tsk/info/child/list',
      method: 'post',
      data,
    })
  },
  personalTskInfoCenterActionApi(data = {}) {
    return request({
      url: '/digitalCenter/tsk/info/action',
      method: 'post',
      data,
    })
  },
  personalTskInfoCancelApi(data = {}) {
    return request({
      url: '/digitalCenter/tsk/info/cancel',
      method: 'post',
      data,
    })
  },
  personalTskInfoDetailApi(data = {}) {
    return request({
      url: '/digitalCenter/tsk/info/detail',
      method: 'post',
      data,
    })
  },
  personalTskInfoAssignmentsApi(data = {}) {
    return request({
      url: '/digitalCenter/tsk/info/assignments',
      method: 'post',
      data,
    })
  },
  personalTskInfoTskStatusApi(data = {}) {
    return request({
      url: '/digitalCenter/tsk/info/tsk/status',
      method: 'post',
      data,
    })
  },
  personalTskQuotedGoodsDetailApi(data = {}) {
    return request({
      url: '/digitalCenter/tsk/quoted/goods/detail',
      method: 'post',
      data,
    })
  },
  personalTskQuotedGoodsUpdateQuotedApi(data = {}) {
    return request({
      url: '/digitalCenter/tsk/quoted/goods/update/quoted',
      method: 'post',
      data,
    })
  },
  personalTskQuotedGoodsSpecListApi(data = {}) {
    return request({
      url: '/digitalCenter/tsk/quoted/goods/spec/list',
      method: 'post',
      data,
    })
  },
  personalTskLogListApi(data = {}) {
    return request({
      url: '/digitalCenter/tsk/log/list',
      method: 'post',
      data,
    })
  },
  personalTskTodoListApi(data = {}) {
    return request({
      url: '/digitalCenter/tsk/todo/list',
      method: 'post',
      data,
    })
  },
  personalTskInfoTimeoutListApi(data = {}) {
    return request({
      url: '/digitalCenter/tsk/info/timeout/list',
      method: 'post',
      data,
    })
  },
  personalTskInfoScheduleListApi(data = {}) {
    return request({
      url: '/digitalCenter/tsk/info/schedule/list',
      method: 'post',
      data,
    })
  },
  personalTskInfoRelatedListApi(data = {}) {
    return request({
      url: '/digitalCenter/tsk/info/related/list',
      method: 'post',
      data,
    })
  },
  personalTskInfoMarkedListApi(data = {}) {
    return request({
      url: '/digitalCenter/tsk/info/marked/list',
      method: 'post',
      data,
    })
  },
  personalTskInfoTotalApi(data = {}) {
    return request({
      url: '/digitalCenter/tsk/info/total',
      method: 'post',
      data,
    })
  },
  personalTskMarkAddApi(data = {}) {
    return request({
      url: '/digitalCenter/tsk/mark/add',
      method: 'post',
      data,
    })
  },
  personalTskMarkDelApi(data = {}) {
    return request({
      url: '/digitalCenter/tsk/mark/del',
      method: 'post',
      data,
    })
  },
  personalTskRemarkListApi(data = {}) {
    return request({
      url: '/digitalCenter/tsk/remark/list',
      method: 'post',
      data,
    })
  },
  personalTskRemarkSaveApi(data = {}) {
    return request({
      url: '/digitalCenter/tsk/remark/save',
      method: 'post',
      data,
    })
  },
  personalTskRemarkDetailApi(data = {}) {
    return request({
      url: '/digitalCenter/tsk/remark/detail',
      method: 'post',
      data,
    })
  },
  personalTskRemarkDelApi(data = {}) {
    return request({
      url: '/digitalCenter/tsk/remark/del',
      method: 'post',
      data,
    })
  },
})
